import { Routes } from '@angular/router';

import { privateRouteGuard } from '@guards/private-route.guard';

import { AGENCY_ROUTES } from '@pages/agency/routes';
import { AUTHENTICATION_ROUTES } from '@pages/authentication/routes';
import { PROJECT_ROUTES } from '@pages/project-details/routes';
import { UPGRADE_ROUTES } from '@pages/project-details/upgrade-upsert/routes';
import { REQUEST_ACCESS_ROUTES } from '@pages/request-access/routes';
import { RESERVATION_ROUTES } from '@pages/reservation/routes';
import { SALES_PIPELINE_ROUTES } from '@pages/sales-pipeline/routes';
import { SETTINGS_ROUTES } from '@pages/settings/routes';
import { USERS_ROUTES } from '@pages/users/routes';

export const routes: Routes = [
  ...AUTHENTICATION_ROUTES,
  ...PROJECT_ROUTES,
  ...RESERVATION_ROUTES,
  ...SALES_PIPELINE_ROUTES,
  ...REQUEST_ACCESS_ROUTES,
  ...AGENCY_ROUTES,
  ...UPGRADE_ROUTES,
  ...USERS_ROUTES,
  ...SETTINGS_ROUTES,
  {
    path: '',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@pages/precinct-listing/precinct-listing.component').then(
            (c) => c.PrecinctListingComponent,
          ),
        data: { layout: 'private' },
      },
    ],
    data: { layout: 'private' },
    canActivate: [privateRouteGuard],
    canActivateChild: [privateRouteGuard],
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
